import { MapMarkerRendererProps } from './map-marker-renderer.props';

export const areMapMarkerRendererPropsEqual = (
    prevProps: MapMarkerRendererProps,
    nextProps: MapMarkerRendererProps,
): boolean => {
    const prevIsHovered = prevProps.hoveredId === prevProps.marker.id;
    const nextIsHovered = nextProps.hoveredId === nextProps.marker.id;
    const prevIsSelected = prevProps.selectedId === prevProps.marker.id;
    const nextIsSelected = nextProps.selectedId === nextProps.marker.id;

    const arePropsEqual =
        prevProps.marker.id === nextProps.marker.id &&
        prevIsHovered === nextIsHovered &&
        prevIsSelected === nextIsSelected &&
        prevProps.totalItems === nextProps.totalItems;

    return arePropsEqual;
};
